module.exports = "/assets/data/7ad4a9e3e1ab046719940dbd2aea889c-BD17.data.json";